import { render, staticRenderFns } from "./IImgTitle.vue?vue&type=template&id=2d2be88d&"
import script from "./IImgTitle.vue?vue&type=script&lang=js&"
export * from "./IImgTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports